module.exports = "/packs/images/homepage/facilities/faqs~13e1c804242438532fdb3c98e5533437.jpg";